/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';

import template from './review-reject-modal.component.html';
import {REJECTED_REASONS} from './review-commons';
import {CreativeResource} from '../../components/api/resources/resource/creative.resource';
import {LineItemResource} from '../../components/api/resources/resource/line-item.resource';

@Component({
  standalone: false,
  selector: 'adn-review-reject-modal',
  template
})
export class ReviewRejectModalComponent {
  reviewItem: any;
  creative: any;
  onComplete: () => void;

  rejectedReason: string;
  reasons = REJECTED_REASONS;
  form: any = {};

  constructor(
    public bsModalRef: BsModalRef,
    @Inject(CreativeResource) private readonly Creative: any,
    @Inject(LineItemResource) private readonly LineItem: any
  ) {
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }

  review(): void {
    const creativeResource = new this.Creative({
      id: this.creative.creative.id,
      userState: 'REJECTED',
      rejectedReason: this.rejectedReason
    });

    creativeResource.savePartial().then(() => {
      const lineItemResource = new this.LineItem({id: this.reviewItem.lineItem.id, userState: 'PROPOSED'});
      lineItemResource.savePartial().catch(() => {
        this.form.bulkError = true;
      }).finally(() => {
        this.onComplete?.();
        this.bsModalRef.hide();
      });
    }, () => {
      this.form.bulkError = true;
      this.onComplete?.();
      this.bsModalRef.hide();
    });
  }
}
